import Vue from 'vue'
import sub_button from '../../src/components/sub_button.vue'

function plugin(Vue){
    if(plugin.installed) return;
    Vue.component('sub_button',sub_button);
}

export default plugin


//////////////////
// WEBPACK FOOTER
// ./static/plugins/components.js
// module id = null
// module chunks = 